import { ENV } from '../config/environment'

// Temporary debug helper — logs all available shop resolution sources.
// Remove this function once the correct resolution path is confirmed.
function debugSources(): void {
  if (typeof window === 'undefined') return

  console.group('[shop] resolution debug')
  console.log('window.location.href:     ', window.location.href)
  console.log('window.location.search:   ', window.location.search)
  console.log('document.referrer:        ', document.referrer)

  const origins = window.location.ancestorOrigins
  console.log('ancestorOrigins:          ', origins ? Array.from(origins) : 'unavailable')

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const shopifyGlobal = (window as any).shopify
  if (shopifyGlobal) {
    console.log('window.shopify keys:      ', Object.keys(shopifyGlobal))
    console.log('window.shopify.config:    ', shopifyGlobal.config)
    console.log('window.shopify.environment:', shopifyGlobal.environment)
  } else {
    console.log('window.shopify:            not present')
  }

  console.log('ENV.SHOP_DOMAIN:          ', ENV.SHOP_DOMAIN)
  console.groupEnd()
}

function resolveShop(): string {
  if (typeof window === 'undefined') return ENV.SHOP_DOMAIN

  debugSources()

  // 1. ?shop= in the current URL — Shopify injects this when loading the embedded app.
  const urlShop = new URLSearchParams(window.location.search).get('shop')
  if (urlShop) {
    console.log('[shop] resolved via URL param:', urlShop)
    return urlShop
  }

  // 2. App Bridge v4 global — available when the CDN script is loaded inside the
  //    Shopify admin iframe. Requires the app-bridge.js script tag in index.html.
  const appBridgeShop = (window as { shopify?: { config?: { shop?: string } } })
    .shopify?.config?.shop
  if (appBridgeShop) {
    console.log('[shop] resolved via App Bridge:', appBridgeShop)
    return appBridgeShop
  }

  // 3. Parse store handle from document.referrer.
  //    admin.shopify.com loads embedded apps at /store/{handle}/apps/... so the
  //    referrer URL contains the store handle in a predictable path segment.
  const referrer = document.referrer
  const referrerMatch = referrer.match(/admin\.shopify\.com\/store\/([^/?#]+)/)
  if (referrerMatch?.[1]) {
    const shop = `${referrerMatch[1]}.myshopify.com`
    console.log('[shop] resolved via referrer:', shop, '(referrer:', referrer, ')')
    return shop
  }

  // 4. ENV fallback — VITE_SHOP_DOMAIN set in .env.local for local dev.
  console.log('[shop] falling back to ENV.SHOP_DOMAIN:', ENV.SHOP_DOMAIN)
  return ENV.SHOP_DOMAIN
}

// Resolved eagerly at module load. If App Bridge wasn't ready yet (CDN script
// not yet executed), getShop() retries on first call so the component lifecycle
// (useEffect runs after mount, giving App Bridge time to initialize) gets a
// second chance.
let _shop = resolveShop()

export function getShop(): string {
  if (!_shop) {
    _shop = resolveShop()
    console.log('[shop] late-resolved shop:', _shop)
  }
  return _shop
}

export function setShop(domain: string): void {
  console.log('[shop] setShop called:', domain)
  _shop = domain
}
